import { render, staticRenderFns } from "./DonorSummary.vue?vue&type=template&id=c0005b8e"
import script from "./DonorSummary.vue?vue&type=script&lang=js"
export * from "./DonorSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports